/**
 * @fileoverview CSS module for the AudioPlayer component.
 * Contains styles for the audio player controls and layout.
 *
 * @example
 * // Import and use in component
 * import css from './AudioPlayer.module.css'
 *
 * <div className={css.container}>
 *   <audio controls />
 * </div>
 */


.container {
    display: flex;
    align-items: center;
    justify-content: center;
}
